// @flow
type TBet = {
    name?: string,
};

type TBetState = {
    data: TBet,
};
const initialState: TBetState = {
    data: {},
};

type TSetThreatChipsCount = {payload: {chipsCount: number, zoneId: number}, type: 'SET_THREAT_CHIPS_COUNT'};
type TSetSafeChipsCount = {payload: {chipsCount: number, zoneId: number}, type: 'SET_SAFE_CHIPS_COUNT'};
type TSetThreatInMove = {payload: {chipsCount: number, zoneId: number}, type: 'SET_THREAT_IN_MOVE'};
type TSetSafeInMove = {payload: {chipsCount: number, zoneId: number}, type: 'SET_SAFE_IN_MOVE'};
type TSetIsThreat = {payload: {isThreat: boolean, zoneId: number}, type: 'SET_IS_THREAT'};
type TSetFrequency = {payload: {frequency: number, zoneId: number}, type: 'SET_FREQUENCY'};
type TUpdateBetList = {payload: Object, type: 'UPDATE_BET_LIST'};

type TBetActionList = TSetThreatChipsCount | TSetSafeChipsCount | TSetIsThreat | TSetFrequency | TUpdateBetList;

function betReducer(state: TBetState = initialState, {type, payload}: TBetActionList) {
    switch (type) {
        case 'SET_FREQUENCY':
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.zoneId]: {
                        ...state.data[payload.zoneId],
                        frequency: payload.frequency,
                    },
                },
            };
        case 'SET_IS_THREAT':
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.zoneId]: {
                        ...state.data[payload.zoneId],
                        isThreat: payload.isThreat,
                    },
                },
            };
        case 'SET_SAFE_CHIPS_COUNT':
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.zoneId]: {
                        ...state.data[payload.zoneId],
                        safeChipsCount: payload.chipsCount,
                    },
                },
            };
        case 'SET_SAFE_IN_MOVE':
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.zoneId]: {
                        ...state.data[payload.zoneId],
                        safeInMove: payload.chipsCount,
                    },
                },
            };
        case 'SET_THREAT_CHIPS_COUNT':
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.zoneId]: {
                        ...state.data[payload.zoneId],
                        threatChipsCount: payload.chipsCount,
                    },
                },
            };

        case 'SET_THREAT_IN_MOVE':
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.zoneId]: {
                        ...state.data[payload.zoneId],
                        threatInMove: payload.chipsCount,
                    },
                },
            };
        case 'UPDATE_BET_LIST': {
            const newData = {...state.data};
            Object.keys(payload).forEach((zoneKey) => {
                const newItem = {
                    ...newData[zoneKey],
                    ...payload[zoneKey],
                };
                if (!newItem.safeInMove) {
                    newItem.safeInMove = 0;
                }

                if (!newItem.threatInMove) {
                    newItem.threatInMove = 0;
                }

                newData[zoneKey] = newItem;
            });
            return {
                ...state,
                data: newData,
            };
        }
        default:
            return state;
    }
}

export {betReducer};
export type {
    TBet,
    TBetState,
    TSetThreatInMove,
    TSetSafeInMove,
    TSetThreatChipsCount,
    TSetSafeChipsCount,
    TSetIsThreat,
    TSetFrequency,
    TUpdateBetList,
};
